import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import type { AccountReduxState } from "@app/modules/account";

import type { ReduxProps, ReduxActions } from "./user-credit-balance";
import type { Dispatch } from "@reduxjs/toolkit";

import { UserCreditBalance } from "./user-credit-balance";
import { openModal } from "../../store/state/modals";

const mapStateToProps = (state: AccountReduxState): ReduxProps => {
  const { redeemable_amounts } = state;

  return {
    balance:
      (redeemable_amounts?.user_balance.value ?? 0) +
      (redeemable_amounts?.loyalty_balance.value ?? 0),
    currency: redeemable_amounts?.user_balance.currency
  };
};

const mapDispatchToProps = (dispatch: Dispatch): ReduxActions =>
  bindActionCreators(
    { openActivityModal: () => openModal({ type: "view_credits_activity" }) },
    dispatch
  );

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(UserCreditBalance);
